import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'discapacidadStringPipe',
    standalone: false
})
export class DiscapacidadStringPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    switch (value) {
      case '0': return 'No';
      case '': return 'No';
      case '1': return 'Si';
    }
    return value;
  }
}
